import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomFlexLayoutModule } from '../../../flex-layout/custom-flex-layout.module';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'calsoft-editor-text-child',
  imports: [CustomFlexLayoutModule,MatIconModule],
  templateUrl: './editor-text-child.component.html',
  styleUrl: './editor-text-child.component.scss'
})
export class EditorTextChildComponent {
  trustedHtmlContent: any;
  @Input() text: any;

  @Input() align: any;

  @Input() data: any;

  @Input() fontSize: any;

  @Input() MobfontSize: any;

  @Input() fontFamily: any;

  @Input() id: any;

  constructor(
   private sanitizer: DomSanitizer,
   

  ) {
    
  }

  ngOnInit() {    
    this.trustedHtmlContent = this.sanitizer.bypassSecurityTrustHtml(this.text);
  }

}
